import { render, staticRenderFns } from "./AdminSection.vue?vue&type=template&id=bb8931de&scoped=true&"
import script from "./AdminSection.vue?vue&type=script&lang=js&"
export * from "./AdminSection.vue?vue&type=script&lang=js&"
import style0 from "./AdminSection.vue?vue&type=style&index=0&id=bb8931de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8931de",
  null
  
)

export default component.exports